import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { homeForRole } from '../auth/RequireRole';
import { Button } from '../ui/Button';
import { Field } from '../ui/Field';
import { Input } from '../ui/Input';
import { ThemeToggle } from '../ui/ThemeToggle';

export function LoginPage() {
  const { user, login } = useAuth();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={homeForRole(user.role)} replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    const r = await login(identifier.trim(), password);
    setBusy(false);
    if (!r.ok) setError(r.error);
  }

  return (
    <div className="min-h-screen bg-bg text-fg flex flex-col">
      <header className="flex items-center justify-between px-6 py-5">
        <div className="flex items-baseline gap-2">
          <span
            className="font-display text-[20px] font-semibold"
            style={{ fontVariationSettings: '"opsz" 48, "SOFT" 20' }}
          >
            board
          </span>
          <span className="text-[10px] uppercase tracking-[0.12em] text-muted">matemasha</span>
        </div>
        <ThemeToggle />
      </header>

      <main className="flex-1 flex items-center justify-center px-4 pb-20">
        <div className="w-full max-w-[380px]">
          <h1
            className="font-display text-[48px] leading-none font-medium mb-2"
            style={{ fontVariationSettings: '"opsz" 144, "SOFT" 20' }}
          >
            Вход
          </h1>
          <p className="font-caps italic text-[13px] text-muted mb-8">
            Для репетитора · доска и база учеников
          </p>

          <form onSubmit={onSubmit} className="space-y-4">
            <Field label="Email или телефон" hint="Телефон можно в любом виде: +7 916 …, 8 916 …">
              <Input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                autoComplete="username"
                autoFocus
              />
            </Field>
            <Field label="Пароль">
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                autoComplete="current-password"
              />
            </Field>
            {error ? (
              <p className="text-[12px] text-accent border border-accent/30 bg-accent-soft px-3 py-2 rounded">
                {error}
              </p>
            ) : null}
            <Button type="submit" disabled={busy} className="w-full h-9">
              {busy ? 'Входим…' : 'Войти'}
            </Button>
          </form>
        </div>
      </main>

      <footer className="px-6 py-4 text-[11px] text-muted font-caps italic">
        board.matemasha · 2026
      </footer>
    </div>
  );
}
